import { createContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';
import { useTranslation } from 'react-i18next';
import api from './authApi';
import dashboardUrls from '../utils/urlsDictionary';

const AuthServiceContext = createContext();

const AuthService = ({ children }) => {
  const navigate = useNavigate();
  const [authenticated, setAuthenticated] = useState(false);
  const [error, setError] = useState(null);
  const { i18n } = useTranslation();
  const lang = i18n.language;

  const login = async (credentials) => {
    try {
      const response = await api.post('/Auth/LogIn', credentials);

      if (response.status === 200) {
        const { isSuccess, message } = response.data;
        if (!isSuccess) {
          setError(message);
        } else {
          const { token, userTypeId } = response.data;

          Cookies.set('Token', token);
          localStorage.setItem('userTypeId', userTypeId);
          setAuthenticated(true);
          //console.log(tk);

          if (dashboardUrls.hasOwnProperty(userTypeId)) {
            navigate(`/${lang}${dashboardUrls[userTypeId]}`);
          } else {
            // Handle the case when userTypeId does not exist
            navigate(`/${lang}`);
          }
        }
      } else {
        setError('Authentication failed. Please check your credentials.');
      }
    } catch (error) {
      setError(error.message);
    }
  };

  const logout = async () => {
    try {
      const token = Cookies.get('Token');
      Cookies.remove('Token');

      localStorage.removeItem('IsAdmin');

      setAuthenticated(false);

      navigate(`/${lang}/login`);
      const response = await api.post(
        '/Auth/LogOut',
        {},
        {
          headers: {
            Authorization: token,
          },
        }
      );
      if (response.status === 200) {
        const { isSuccess, message } = response.data;
        if (!isSuccess) {
          alert(message);
        } else {
          navigate(`/${lang}/login`);
        }
      }
    } catch (error) {}
  };

  return (
    <AuthServiceContext.Provider value={{ authenticated, login, logout, error }}>
      {children}
    </AuthServiceContext.Provider>
  );
};

export { AuthService, AuthServiceContext };
